"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLayers(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.536 16.41l.099.056 1.02.674c.463.306.452.972.014 1.27l-.1.059-11.234 5.453a.766.766 0 01-.56.043l-.109-.043L.433 18.469c-.599-.29-.538-1.08-.051-1.357l.036-.02.948-.625a.766.766 0 01.992.126l.07.09c.19.289.16.66-.05.912l-.077.078 9.7 4.708 9.697-4.708-.074-.077a.767.767 0 01-.106-.813l.056-.1a.766.766 0 01.962-.272zm0-5.105l.099.055 1.02.674c.463.305.452.972.014 1.27l-.1.058-11.234 5.454a.766.766 0 01-.56.043l-.109-.043L.433 13.362c-.599-.29-.538-1.08-.051-1.356l.036-.02.948-.625a.766.766 0 01.992.126l.07.09c.19.289.16.66-.05.912l-.077.078 9.7 4.708 9.697-4.708-.074-.077a.767.767 0 01-.106-.813l.056-.1a.766.766 0 01.962-.272zM11.634.094a.766.766 0 01.733 0L23.601 6.22a.766.766 0 010 1.345l-11.234 6.127a.766.766 0 01-.733 0L.4 7.566C-.2 7.238-.082 6.403.474 6.18zM12 1.638L2.367 6.893l9.634 5.255 9.633-5.256L12 1.638z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgLayers;
exports.default = _default;